export const environment = {
  production: false,
  baseUrl: '',
  useHash: false,
  hmr: false,
  showThemeToggle: true,
  translateText: false,
  collapsibleSidebar: false,
  showChatbot: false,
  build: 'Test',
  domain: 'orelap-staff-api-test.dhsoha.state.or.us',
  api: 'https://orelap-staff-api-test.dhsoha.state.or.us/api/',
  useTimeout: false,
  idleInterval: 90000,
  displaySidebar: true,
  version: '4.0.5',
  theme: 'dark',
  publicApi: 'https://test-orelap-admin.oregon.gov/api/public/',
  privateApi: 'https://test-orelap-admin.oregon.gov/api/private/',
  authEntireSite: true, //will run authentication prior to loading the site, otherwise will only run auth when reqired by routes
  mfa: {
    required: false,
    timeout: 1440 //in minutes: 24 hrs = 1440
  },
  auth: {
    aad: {
      clientId: 'da6bd321-46e2-4b4b-84fa-19901f7f2f06',
      scopes: ['api://da6bd321-46e2-4b4b-84fa-19901f7f2f06/api.access'],
      groups: [],
      authority: 'https://login.microsoftonline.com/658e63e8-8d39-499c-8f48-13adc9452f4c/v2.0',
      redirectUri: 'https://test-orelap-admin.oregon.gov/',
    }
  },
  enableHttpsRedirect: false,
  staffInbox: "chae.shin@odhsoha.oregon.gov"
};
